/**
 * Free-trial state for the in-app notice (C-197).
 *
 * `settings/general.trialEndsAt` is written by the server at self-service
 * signup only (`functions/src/lib/trial.ts`); firestore.rules pin it against
 * client writes. An ABSENT field means "no trial" — contract tenants (Black
 * Fin) and every tenant created before the field existed never see a notice.
 */

/**
 * The team mailbox already published on the Praesto site (footer, privacy,
 * terms). The notice points here — never a person's name or a phone number
 * (D-2026-10-26-07).
 */
export const TEAM_CONTACT_EMAIL = "mademindteam@gmail.com";

export type TrialState =
  | { readonly kind: "none" }
  | { readonly kind: "active"; readonly endsAt: Date }
  | { readonly kind: "ended"; readonly endsAt: Date };

/** `ended` from the end instant onward (day 30 after signup), `active` before. */
export function trialState(endsAt: Date | null, now: Date): TrialState {
  if (endsAt === null || Number.isNaN(endsAt.getTime())) return { kind: "none" };
  return now.getTime() >= endsAt.getTime() ? { kind: "ended", endsAt } : { kind: "active", endsAt };
}

/** "28 novembre 2026" / "28 November 2026", on the Italian calendar day. */
export function formatTrialDate(d: Date, locale: string): string {
  return new Intl.DateTimeFormat(locale === "en" ? "en-GB" : "it-IT", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "Europe/Rome",
  }).format(d);
}
